<template>
    <div>
        <az-break-title title="Médicos Cooperados" />

        <div>

            <div class="row mb-3">
                <div class="col col-12 col-md-9">
                    <az-input icon="fas fa-search" v-model="search">
                        <template v-slot:buttonposb v-if="false">
                            <importacao service="planos" :parms="{ id_operadora: id_operadora }" @refresh="load()" />
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir
                    </button>
                </div>
            </div>

        </div>

        <div v-if="!lista || !lista.length">
            <az-empty-state icon="fa-solid fa-user-doctor" msg="Nenhum médico cooperado identificado." 
                :action="!search ? 'Incluir Médico Cooperado' : ''" :method="incluir" />
		</div>

        <div v-if="lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item" v-for="(dado, id) in lista" :key="id">
                    <div class="d-flex justify-content-between">
                        <span>
                            <a href="#" @click.prevent="editar(dado)" class="card-link">
                                {{ dado.search }}
                            </a>
                        </span>
                        <span>
                            <a href="#" @click.prevent="remover(dado)" class="card-link text-danger">
                                <i class="fa fa-trash" aria-hidden="true"></i>
                            </a>
                        </span>
                    </div>
                </li>
            </div>

        </div>

        <!-- Modal -->
        <div class="modal fade" id="cadastroModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Médico Cooperado
                            {{ item.id_medico_cooperado ? '#' + item.id_medico_cooperado : '(Novo)' }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12">
                                <az-input 
                                    label="Médico Cooperado"
                                    type="select" 
                                    optionsMode="aql"
                                    service="medicos.index"
                                    optionsName="medicos-cadastro-ativos"
                                    :optionsParm="{ ativos: true }"
                                    optionsData="id_pessoa"
                                    v-model="item.id_medico" 
                                    required
                                    :validate="validate" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Observações"
                                    :validate="validate"
                                    type="textarea"
                                    v-model="item.st_obs" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="medicoCooperado" :id="item.id_medico_cooperado" v-if="item && item.id_medico_cooperado" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_medico_cooperado ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzBreakTitle from '../../../util/AzBreakTitle.vue';
import AzEmptyState from '../../../util/AzEmptyState.vue';
import AzInput from '../../../shared/forms/AzInput.vue';
import AzSubmit from '../../../util/AzSubmit.vue';
import AzAuditLogButton from '../../../util/AzAuditLogButton.vue';
import Importacao from '../../shared/Importacao.vue';

export default {
    data () { 
        return { 
            dados: null, 
            search: "",
            item: null,  
            validate: false, 
            viewMode: "A",
        }
    },

    components: { 
        AzBreakTitle,
        AzEmptyState,
        AzInput,
        AzSubmit,
        AzAuditLogButton,
        Importacao
    }, 

    props: ['id_operadora'],

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return !this.search || reg.test(JSON.stringify(item));
                }) : null ; 
        }
    },

    methods: { 
        remover (item) { 

            if ( !confirm('Confirma remover o médico cooperado "' + item.search + '"?') ) { 
                return; 
            }

            this.$util.remover (this, { 
                service: 'medico_cooperados',
                dados: item,
                reload: true, 
                modal: 'cadastroModal',
            });

        },

        incluir () { 
            this.validate = false;
            
            this.item = { 
                id_operadora: this.id_operadora,
                id_medico: "",
                st_obs: null, 
            }

            $('#cadastroModal').modal('show');

        },

        editar (item) { 

            this.validate = false;
            this.item = { ...item };

            $('#cadastroModal').modal('show');

        },

        atualizar () { 

            this.$util.atualizar (this, { 
                service: 'medico_cooperados',
                dados: this.item,
                reload: true, 
                modal: 'cadastroModal',
            });

        },

        load () { 
            this.$util.load(this, { 
                service: 'medico_cooperados',
                func: 'index',
                parms: { 
                    id_operadora: this.id_operadora,
                    cadastro: true, 
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });
        }
    },

    mounted () { 
        this.load (); 
    }
}
</script>